export default "__VITE_ASSET__C6_LED7k__"